import { render, staticRenderFns } from "./CmgStudentRegistrationSuccessModal.vue?vue&type=template&id=3eebaf51&scoped=true&lang=pug"
import script from "./cmg-student-registration-success-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-student-registration-success-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgStudentRegistrationSuccessModal.vue?vue&type=style&index=0&id=3eebaf51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eebaf51",
  null
  
)

export default component.exports